import React from "react";
import {
  TGroupChatHistoryMessage,
  TGroupChatMessageFile,
} from "../../api/group_chat/get_history";
import ST from "../../assets/styles/organisms/chatMessageHistory.module.scss";
import {
  MESSAGE_FILE_TYPE_IMAGES,
  MESSAGE_TYPE_FILE,
  formatMessageHistoryDateTime,
} from "../../utils/chat/messageHistoryUtils";
import { getChannelMemberForMessage } from "./messageHistoryDisplay";
import ChatMessageHistoryImage from "./ChatMessageHistoryImage";

export const renderMessageCell = (
  message: TGroupChatHistoryMessage,
  downloadFile: (file: TGroupChatMessageFile) => void,
) => {
  if (message.message_type === MESSAGE_TYPE_FILE) {
    return (
      <>
        {message.chat_message_files?.map((file) => {
          if (
            file.file_type === MESSAGE_FILE_TYPE_IMAGES &&
            message.chat_message_files
          ) {
            return (
              <ChatMessageHistoryImage
                key={"file_" + file.id}
                className={ST.file_image}
                file={file}
                files={message.chat_message_files}
                downloadFile={downloadFile}
              />
            );
          }
          return (
            <button
              type="button"
              key={"file_" + file.id}
              className={ST.file_link}
              onClick={() => downloadFile(file)}
            >
              {file.file_name}
            </button>
          );
        })}
      </>
    );
  }
  return <div className={ST.message_text}>{message.message}</div>;
};

type Props = {
  data: TGroupChatHistoryMessage[];
  siteName: string | undefined;
  downloadFile: (file: TGroupChatMessageFile) => void;
};

const ChatMessageHistoryList: React.FC<Props> = ({
  data,
  siteName,
  downloadFile,
}) => {
  return (
    <>
      {data.map((message) => (
        <div
          className={ST.message_card}
          key={"message_" + message.sendbird_message_id}
        >
          <div className={ST.message_sender_col}>
            <div className={ST.message_sender}>
              {getChannelMemberForMessage(message, siteName)}
            </div>
            <div className={ST.message_time}>
              {message.created_at
                ? formatMessageHistoryDateTime(message.created_at)
                : ""}
            </div>
          </div>
          <div className={ST.message_body_col}>
            {renderMessageCell(message, downloadFile)}
          </div>
        </div>
      ))}
    </>
  );
};

export default ChatMessageHistoryList;
